import { useEffect, useState } from "react";
/**
 *
 * @param ref A ref to the element whose index we want to find
 * @returns It's index in the parent's children array & length of the parent's children array
 */ const useChildIndex = (ref)=>{
    const [childIndex, setChildIndex] = useState(null);
    useEffect(()=>{
        if (ref.current) {
            let parent = ref.current.parentElement;
            if (parent) {
                let me = ref.current;
                let children = Array.from(parent.children);
                if (children.length === 1) {
                    // Try one level up
                    me = parent;
                    parent = parent.parentElement;
                    if (parent) {
                        children = Array.from(parent.children);
                    }
                }
                let index = children.indexOf(me);
                setChildIndex({
                    index,
                    length: children.length
                });
            }
        }
    }, [
        ref
    ]);
    return childIndex ? {
        ...childIndex,
        isFirst: childIndex.index === 0,
        isLast: childIndex.index === childIndex.length - 1
    } : null;
};
export default useChildIndex;
